<template>

  <t-page>

    <t-dialog-duplicate dialog-id="modal-duplicate-profile" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError" v-model="formDuplicate"
                        :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">

        <t-input hide-label :status="status" v-model="formDuplicate.profileId" hidden/>
        <t-input label="Nome do novo perfil de acesso" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>

    </t-dialog-duplicate>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">

          <div v-if="item.typeMaster">
            {{ item.name }}
            <i class="fa fa-fw text-warning ml-2" v-b-tooltip.hover title="Perfil Master"></i>
          </div>

          <t-list-link-primary v-else :label="item.name" :userAuth="userAuth" :id="item.profileNumber"
                               :path="currentPage.path"/>


        </template>

        <template #cell(modulesAccess)="{item}">

          {{ item.modulesAccess }}

          <div v-if="item.enableUsersAccessCode" class="small">Perfil habilitado para usuários com acesso via Código
            (menos seguro)
          </div>
        </template>


        <template #cell(quantityAccessDelete)="{item}">
          <span class="text-danger">{{ item.quantityAccessDelete }}</span>
        </template>


        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">

          <div class="d-flex listActions justify-content-end">

            <b-button @click="openDialogDuplicate(item.profileId,item.name)"
                      class="opacity-6-hover"
                      v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                      title="Duplicar Perfil de Acesso">

              <b-icon-files variant="primary"/>

            </b-button>


            <t-list-actions-default :form-path="currentPage.path" :disable-delete="item.typeMaster"
                                    :id="item.profileNumber" :userAuth="userAuth"/>

          </div>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogDuplicate},
  name: 'Profile',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Perfil de Acesso"},
        {key: "modulesAccess", label: "Modulos habilitados"},
        {key: "quantityAccessGeneral", label: "Recursos geral"},
        {key: "quantityAccessDelete", label: "Recursos exclusão"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      formDuplicateShow: false,
      formDuplicate: {
        profileId: 0,
        origin: "",
        changeName: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'admin-setting'}}
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogDuplicate(profileId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.profileId = profileId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate-profile')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicado", "Novo perfil <b>" + item.title + "</b> duplicado com sucesso!", "success", "b-toaster-top-center", true)

      this.getPage(this.pageNumber)
    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
